import {
  CREATE_VISIT_REMARK,
  CREATE_VISIT_REMARK_ERROR,
  CREATE_VISIT_REMARK_SUCCESS_ACTION,
  GET_REMARKS,
  GET_REMARKS_ERROR,
  GET_VISITS,
  GET_VISITS_SUCCESS,
  VISITS_SET_ERROR,
} from '../../store/visits/VisitsConstants'
import { NETWORK_ERROR } from '../authState'

export const visitsPageBlackList = [
  GET_VISITS,
  GET_VISITS_SUCCESS,
  GET_REMARKS,
  CREATE_VISIT_REMARK_SUCCESS_ACTION,
  VISITS_SET_ERROR,
  CREATE_VISIT_REMARK,
  CREATE_VISIT_REMARK_ERROR,
  GET_REMARKS_ERROR,
  NETWORK_ERROR,
]
